import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import SmoothScroll from "smooth-scroll";

export const Navigation = ({ data, onLanguageChange }) => {
  const history = useHistory();
  const isAuthenticated = localStorage.getItem("authenticated") === "true";
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [language, setLanguage] = useState("en"); // Estado del idioma seleccionado
  const menuRef = useRef(null);

  const availableLanguages = ["en", "es", "no", "ar", "ru", "uk"]; // Idiomas disponibles

  useEffect(() => {
    // 🔹 Detectar idioma del navegador o recuperar del localStorage
    const savedLanguage = localStorage.getItem("selectedLanguage");
    const browserLang = navigator.language.split("-")[0]; // Tomamos solo el código del idioma

    if (savedLanguage && availableLanguages.includes(savedLanguage)) {
      setLanguage(savedLanguage);
      onLanguageChange(savedLanguage);
    } else if (availableLanguages.includes(browserLang)) {
      setLanguage(browserLang);
      onLanguageChange(browserLang);
      localStorage.setItem("selectedLanguage", browserLang); // Guardamos la preferencia
    }

    // 🔹 Iniciar smooth-scroll
    new SmoothScroll('a[href*="#"]', {
      speed: 1000,
      speedAsDuration: true,
    });
  }, []);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    onLanguageChange(lang);
    localStorage.setItem("selectedLanguage", lang); // Guardar preferencia del usuario
  };

  const handleNavigation = (e, href) => {
    e.preventDefault();
    if (href.startsWith("#")) {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      history.push(href);
      window.scrollTo(0, 0);
    }
    setIsMenuOpen(false);
  };

  const handleB2BClick = (e) => {
    e.preventDefault();
    history.push(isAuthenticated ? "/b2b" : "/login");
    window.scrollTo(0, 0);
    setIsMenuOpen(false);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle ${isMenuOpen ? "" : "collapsed"}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <img src="/img/AVIA_green.png" alt="AVIA Green Logo" style={styles.imgLogo} />
        </div>

        <div ref={menuRef} className={`collapse navbar-collapse ${isMenuOpen ? "in" : ""}`}>
          <ul className="nav navbar-nav navbar-right">
            {data?.links
              ? data.links.map((link, i) => (
                  <li key={i}>
                    <a href={link.href} className="page-scroll" onClick={(e) => handleNavigation(e, link.href)}>
                      {link.label}
                    </a>
                  </li>
                ))
              : "Loading..."}

            <li>
              <a href="/b2b" onClick={handleB2BClick} style={{ cursor: "pointer" }}>
                B2B
              </a>
            </li>

            <li>
              <div style={styles.languageSelectorContainer}>
                <select value={language} onChange={(e) => handleLanguageChange(e.target.value)} style={styles.languageSelector}>
                  <option value="en">English</option>
                  <option value="es">Español</option>
                  <option value="no">Norsk</option>
                  <option value="ar">العربية</option>
                  <option value="ru">Русский</option>
                  <option value="uk">Українська</option>
                </select>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

// Estilos en línea
const styles = {
  languageSelectorContainer: {
    textAlign: "center",
    marginTop: "10px",
    padding: "8px 2px",
  },
  imgLogo: {
    width: "120px",
  },
  languageSelector: {
    padding: "5px",
    borderRadius: "4px",
    backgroundColor: "#f9f9f9",
    border: "1px solid #ddd",
    fontSize: "16px",
    cursor: "pointer",
  },
};
